import { DialogContentText } from "@material-ui/core";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface CountryDeleteDialogProps {
    confirmButtonState: ConfirmButtonTransitionState;
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    name: string;
  }

  const CountryDeleteDialog: React.FC<CountryDeleteDialogProps> = ({
    name,
    confirmButtonState,
    onClose,
    onConfirm,
    open
  }) => {
    const intl = useIntl();
    return (
      <ActionDialog
        open={open}
        onClose={onClose}
        confirmButtonState={confirmButtonState}
        onConfirm={onConfirm}
        variant="delete"
        title={intl.formatMessage({
          defaultMessage: "Delete country",
          description: "dialog title"
        })}
      >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="Are you sure you want to delete {countryName}?"
            description="dialog content"
            values={{
              countryName: <strong>{name}</strong>
            }}
          />
        </DialogContentText>
      </ActionDialog>
    );
  };
  export default CountryDeleteDialog;
  